document.addEventListener("DOMContentLoaded", function () {
  let ingredientsSliders = document.querySelectorAll(".ingredients-slider");
  ingredientsSliders.forEach(function (slider) {
    let ingredientsSlider = new Splide(slider, {
    arrowPath:
      "M34.7,21.5c-0.3,0-0.4,0-0.6,0c-10.8,0-21.5,0-32.3,0c-0.4,0-0.9,0-1.2-0.3c-0.5-0.4-0.7-1-0.5-1.7c0.2-0.6,0.7-1,1.4-1.1\n" +
      "\t\tc0.2,0,0.3,0,0.5,0c10.7,0,21.5,0,32.2,0c0.2,0,0.3,0,0.6,0c-0.2-0.2-0.3-0.3-0.4-0.4c-3.1-3.1-6.1-6.1-9.2-9.2\n" +
      "\t\tc-0.5-0.5-0.7-1-0.5-1.6c0.3-1.1,1.5-1.5,2.4-0.9c0.2,0.1,0.3,0.3,0.4,0.4c3.9,3.9,7.9,7.9,11.8,11.8c0.9,0.9,0.9,1.7,0,2.7\n" +
      "\t\tc-4,4-7.9,7.9-11.9,11.9c-0.4,0.4-0.9,0.7-1.5,0.6c-1.2-0.2-1.7-1.6-0.9-2.5c0.2-0.2,0.3-0.3,0.5-0.5c3-3,5.9-5.9,8.9-8.9\n" +
      "\t\tC34.4,21.8,34.5,21.7,34.7,21.5z",
    fixedWidth: 305,
    gap: "1rem",
    mediaQuery: "min", // use min-width breakpoints (mobile first)
    padding: 24,
    pagination: false,
    rewind: false,

    breakpoints: {
      750: {
        padding: 50,
      },
      990: {
        fixedWidth: 362,
      },
    },
  });
  ingredientsSlider.mount();
});
});
